import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconCopy = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7935_159664)">
            <path d="M16.6877 2.34514L14.654 0.311445C14.4565 0.111928 14.1842 0 13.902 0H8.46996C7.29623 0 6.34496 0.951602 6.34496 2.125L6.34561 10.625C6.37484 11.8004 7.32777 12.75 8.49984 12.75H14.8748C16.0436 12.75 16.9998 11.7938 16.9998 10.625V3.09619C16.9998 2.81463 16.887 2.54436 16.6877 2.34514ZM15.4061 10.625C15.4061 10.9184 15.1682 11.1562 14.8748 11.1562H8.46996C8.17651 11.1562 7.93871 10.9184 7.93871 10.625V2.12932C7.93871 1.83593 8.17658 1.59807 8.46996 1.59807H12.72L12.7498 3.1875C12.7498 3.7742 13.2256 4.25 13.8123 4.25H15.3762V10.625H15.4061ZM9.03109 14.875C9.03109 15.1684 8.79323 15.4062 8.49984 15.4062H2.09496C1.80151 15.4062 1.56371 15.1684 1.56371 14.875L1.59293 6.37832C1.59293 6.08494 1.8308 5.84707 2.12418 5.84707H5.31234V4.25H2.12451C0.950781 4.25 -0.000488281 5.20127 -0.000488281 6.375L-0.000162891 14.875C-8.98437e-05 16.0471 0.951445 17 2.12484 17H8.49984C9.66859 17 10.6248 16.0438 10.6248 14.875V13.8125H9.06098L9.03109 14.875Z" fill={color}/>
            </g>
            <defs>
            <clipPath id="clip0_7935_159664">
            <rect width="17" height="17" fill="white"/>
            </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCopy;
